module.exports = __webpack_public_path__ + "static/logo-black-773b031b2757366a6c71f6660b7ce009.png";